import { formatDateShort } from 'src/utils/helpers/transformDate';
import { calcDuration } from 'src/utils/helpers/calcDuration';
import {
	COMPANY_STATUS_CODE,
	getStatusPlateColor,
	resolveCompanyStatus,
} from 'src/utils/mappers/companyStatus.mapper';

const formatDateLabel = (dateString) => {
	if (!dateString) return '';

	const formatted = formatDateShort(dateString);

	return formatted.split(' в ')[0] || '';
};

const formatDaysInStatus = (statusAt) => {
	const days = calcDuration({ statusAt }, 'statusAt');

	if (days === null || days === undefined) return null;

	const n = Math.abs(days) % 100;
	const n1 = n % 10;
	let suffix = 'дней';

	if (!(n > 10 && n < 20)) {
		if (n1 === 1) suffix = 'день';
		else if (n1 > 1 && n1 < 5) suffix = 'дня';
	}

	return `${days} ${suffix} в статусе`;
};

const buildStatusLabel = (company, status) => {
	const { cache } = company;

	if (status.code === COMPANY_STATUS_CODE.POSTPONED) {
		if (cache?.postponedUntil) {
			return `Отложено до ${formatDateLabel(cache.postponedUntil)}`;
		}
	}

	if (status.group?.code === 'in_work') {
		return `В работе: ${status.name}`;
	}

	return status.name;
};

export const mapCompanyStatusPlate = (company, statuses = []) => {
	const status = resolveCompanyStatus(company, statuses);

	return {
		label: buildStatusLabel(company ?? {}, status),
		remark: formatDaysInStatus(company?.statusAt),
		color: getStatusPlateColor(status),
	};
};
